export const SLEXKIT_SITE_VERSION = "0.4.0";
export const SLEX_PROTOCOL_VERSION = "0.1";
